import PageLayout from "@/components/layout/PageLayout";
import { AutoHero } from "@/components/insurance/auto/AutoHero";
import { CoverageOptions } from "@/components/insurance/auto/CoverageOptions";
import { ProtectionFeatures } from "@/components/insurance/auto/ProtectionFeatures";
import { WhyChooseUs } from "@/components/insurance/auto/WhyChooseUs";
import Cities from "@/components/sections/Cities";

const AutoInsurancePage = () => {
  return (
    <PageLayout>
      <AutoHero />
      <CoverageOptions />
      <ProtectionFeatures />
      <WhyChooseUs />
      <Cities />
    </PageLayout>
  );
};

export default AutoInsurancePage;